<template>
  <div class="floor-resource-components clearfix">
    <div class="resource-part" :class="{'part-left': list.listName === 'left', 'part-right': list.listName === 'right'}"
         v-for="(list, indexL) in fileList" :key="indexL">
      <div class="serial-wrapper">
        <div class="serial-item" v-for="(item, index) in list.files" :key="index">{{index + 1}}</div>
      </div>
      <div class="list-wrapper">
        <a class="list-item" v-for="(item, index) in list.files" :key="index"
           @click="downloadFile(item.filedPath, item.name)">
          <span class="title">{{item.name}}</span>
          <span class="course cloud-course cloud-course-20 cloud-course-green-"
                v-if="item.grade">{{item.grade}}</span>
          <span class="course cloud-course cloud-course-20 cloud-course-blue"
                v-if="item.subject">{{item.subject}}</span>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadReName, queryMore } from '@/assets/js/api/cloud'
import { downloadBlobFile } from '@/assets/js/utils/utils'

export default {
  name: 'FloorResource',
  props: {
    floor: {
      type: Array,
      default () {
        return []
      },
    },
  },
  computed: {
    fileList () {
      return [
        {
          listName: 'left',
          files: this.leftList,
        },
        {
          listName: 'right',
          files: this.rightList,
        },
      ]
    },
    leftList () {
      return this.floor.slice(0, 8)
    },
    rightList () {
      return this.floor.slice(8, 16)
    },
  },
  methods: {
    routerPageurl (url) {
      if (url) {
        const params = { playUrl: url }
        queryMore(params).then(res => {
          if (res) {
            const href = res.userName
            window.open(href, '_blank')
          }
        })
      }
    },
    // 下载资源获取地址
    downloadFile (url, name) {
      downloadReName({
        filedPath: url,
        realFileName: name,
      }).then(res => {
        downloadBlobFile(res, name)
      })
    },
  },
}
</script>

<style lang="scss">
.floor-resource-components {
  margin-top: 26px;
  width: 100%;

  .resource-part {
    float: left;
    margin: -12px -12px 0 -12px;
    width: 614px;
    height: 418px;
    padding: 32px 32px 38px 32px;
    background-repeat: no-repeat;
    background-position: center;
    background-size: 100%;
    box-sizing: border-box;
    border-radius: 6px;

    &.part-left {
      margin-right: 8px;
      background-image: url("../../assets/images/cloud/resourse-part-left.png");

      .serial-wrapper {
        background-image: url("../../assets/images/cloud/resour-serial-left.png");
      }
    }

    &.part-right {
      background-image: url("../../assets/images/cloud/resourse-part-right.png");

      .serial-wrapper {
        background-image: url("../../assets/images/cloud/resour-serial-right.png");
      }
    }

    .serial-wrapper {
      float: left;
      width: 22px;
      height: 348px;
      background-repeat: no-repeat;
      background-position: center;
      padding-top: 20px;
      box-sizing: border-box;

      .serial-item {
        margin-bottom: 20px;
        line-height: 20px;
        text-align: center;
        width: 100%;
        height: 20px;
        font-size: 12px;
        color: #fff;
      }
    }

    .list-wrapper {
      float: left;
      margin-left: 20px;
      width: 508px;
      height: 348px;
      padding-top: 20px;
      box-sizing: border-box;

      .list-item {
        display: block;
        margin-bottom: 20px;
        height: 20px;
        font-size: 0;
        cursor: pointer;

        .title {
          display: inline-block;
          vertical-align: middle;
          line-height: 20px;
          max-width: 406px;
          height: 20px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          font-size: 14px;
          color: $--color-text-regular;
        }

        .course {
          margin-left: 8px;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>
